import {
  ButtonTertiary,
  cssColorValue,
  IconPublic,
  screenSmMax,
  semanticColors,
  spacer32,
  Type,
} from '@spotify-internal/encore-web';
import React, { useContext } from 'react';
import styled from 'styled-components';
import { useRouter } from 'next/router';

import { MarketContext } from 'providers/market';
import { pathWithoutMarket } from 'utils/market/market';
import { LanguageSelectionSchema } from 'types/navigation';
import { useTranslation } from 'providers/translations/TranslationProvider';

const LanguageWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  gap: ${spacer32};
  flex: none;
  order: 1;
  flex-grow: 0;
  @media (max-width: ${screenSmMax}) {
    width: 100%;
    flex: none;
    order: 0;
    flex-grow: 0;
    justify-content: flex-end;
  }
`;

const StyledButton = styled(ButtonTertiary)`
  && {
    color: ${cssColorValue(semanticColors.textSubdued)};
    cursor: pointer;
    &:hover {
      color: ${cssColorValue(semanticColors.textBase)};
    }
  }
`;

const StyledButtonText = styled(Type)`
  margin-left: 2px;
`;

type Props = {
  languageSelectionEntry: LanguageSelectionSchema;
};

export const FooterLanguage = ({ languageSelectionEntry }: Props) => {
  const { dir, displayNameWithLanguage } = useContext(MarketContext);
  const { t } = useTranslation();
  const marketSelectReturnToPath = pathWithoutMarket(useRouter().asPath);

  const hrefQueryString = marketSelectReturnToPath
    ? `?returnToPath=${encodeURIComponent(marketSelectReturnToPath)}`
    : '';

  const href = `https://www.spotify.com/select-your-country-region/${hrefQueryString}`;

  return (
    <LanguageWrapper>
      <StyledButton
        aria-label={t(languageSelectionEntry.globeButtonAriaLabel)}
        data-testid="language-selection-trigger"
        iconLeading={IconPublic}
        dir={dir}
        buttonSize="sm"
        condensedAll
        href={href}
      >
        <StyledButtonText variant="mestoBold">{displayNameWithLanguage}</StyledButtonText>
      </StyledButton>
    </LanguageWrapper>
  );
};
